export const initialModalState = {
	open: false,
	data: {},
};

export const modalActions = {
	OPEN: "open",
	CLOSE: "close",
};

export const modalReducer = (state, action) => {
	switch (action.type) {
		case modalActions.OPEN:
			return { ...state, open: true, data: action.payload };
		case modalActions.CLOSE:
			return initialModalState;
		default:
			throw new Error("Invalid action at modal reducer");
	}
};
